import { default as axios } from '../utils/axios.instances' // eslint-disable-line

const axiosInstance = axios.getSTAxios() // eslint-disable-line

export default {
  async getMembers (params) {
    return new Promise((resolve, reject) => {
      axiosInstance.get('/users/', { params }).then((res) => {
        resolve(res.data)
      }).catch((err) => {
        reject(err)
      })
    })
  },

  async addNewMember (obj) {
    return new Promise((resolve, reject) => {
      axiosInstance.post('/users/', obj).then((res) => {
        resolve(res.data)
      }).catch((err) => {
        reject(err)
      })
    })
  },

  async resetMemberPassword (id) {
    return new Promise((resolve, reject) => {
      axiosInstance.post(`/users/${id}/reset_password/`).then((res) => {
        resolve(res.data)
      }).catch((err) => {
        reject(err)
      })
    })
  },

  async removeMember (id) {
    return new Promise((resolve, reject) => {
      axiosInstance.patch(`/users/${id}/archive/`).then((res) => {
        resolve(res.data)
      }).catch((err) => {
        reject(err)
      })
    })
  },

  async editMemberInfo (id, formData) {
    return new Promise((resolve, reject) => {
      axiosInstance.patch(`/users/${id}/`, formData).then((res) => {
        resolve(res.data)
      }).catch((err) => {
        reject(err)
      })
    })
  }
}
